<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uc9PVw/tc-custom/9781526747761.jpg?1705212303033" alt="This image is the cover for the book Test Pilots of the Jet Age"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Test Pilots of the Jet Age
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Eleven daring test pilots recount their experiences at the forefront of aeronautical innovation in this oral history of the Jet Age.</b><br/><br/> In the years after World War II, a select band of British test pilots risked everything in the quest to fly further, faster, and higher than ever before. Their vital work made our modern age of air transport possible. This book captures the stories of eleven such pilots, as told in their own words.<br/><br/> Britain’s aircraft industry was booming in the late 1940s, and the demand for test pilots was seemingly limitless as new aircraft designs—some legendary and others nearly forgotten—were being built. Royal Air Force veterans who had distinguished themselves in the war suddenly had a vital new mission.<br/><br/> First, they pursued the almost mythic goal of breaking the sound barrier. But once this was accomplished, they found themselves approaching speeds no one imagined possible. Their stories of that time are both colorful and insightful—and often tinged with humor. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Colin Higgs, Bruce Vigar
      </h2>
      
      <p class="authorDescription body article">Colin Higgs has more than twenty-five years’ experience in the broadcast and home entertainment industries and for much of that time has co-produced, written and researched aviation documentaries together with Bruce Vigar of Leading Edge TV. Colin’s business, A Flying History, was created to make accessible the unique Peter Keating and John Stroud aviation photograph collections and Colin and Bruce's extensive archive of first-hand interviews with RAF veterans.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Air World
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4dca528f